import {scrollIntoView} from './utils/details-page-utils';
import {SmoothBehaviorOptions} from 'smooth-scroll-into-view-if-needed';
import {searchWidgetId} from '../../../shared/utils/common-utils';

// DETAILS PAGE NAVIGATION, ELEMENT IDS
export const detailsNavigationIdsAndValues = {
  rooms: {
    id: '#rooms',
    value: 'Room Type',
  },
  amenities: {
    id: '#amenities',
    value: 'Facilities',
  },
  location: {
    id: '#location',
    value: 'Location',
  },
  // guestReviews: {
  //   id: '#guest-reviews',
  //   value: 'User Reviews',
  // },
  // similarHotels: {
  //   id: '#similar-hotels',
  //   value: 'Similar Hotels',
  // },
  // QnA: {
  //   id: '#QnA',
  //   value: 'Questions & Answers',
  // },
  // hotelPolicies: {
  //   id: '#hotel-policies',
  //   value: 'Hotel Policies',
  // },
  // aboutProperty: {
  //   id: '#about-property',
  //   value: 'About Property',
  // },
};

// for easy use when ids have to be set in markup, flatten the ids
// this function returns this –
/**
 * {
 *    rooms: "rooms",
 *    amenities: "amenities"
 *    …
 * }
 */

type DetailsNavigationIdsType = {
  [K in keyof typeof detailsNavigationIdsAndValues]: string;
};

export const detailsNavigationIds = Object.keys(detailsNavigationIdsAndValues).reduce(
  (idsAccumulator, currentKey) => {
    return {
      ...idsAccumulator,
      [currentKey]: detailsNavigationIdsAndValues[currentKey].id.replace('#', ''),
    };
  },
  {} as DetailsNavigationIdsType,
);

/**
 *  SCROLL INTO VIEW OPTIONS
 *  (for the usage of node module 'smooth-scroll-into-view-if-needed')
 *
 *  this is the config we use on details page. Others might want to use
 *  their own config on any other page. Hence keeping it here, in details
 *  specific config
 *
 */

export const scrollIntoViewOptions = {
  behavior: 'smooth',
  duration: 1000,
  block: 'start',
  inline: 'start',
};

/**
 * If there's a hash on details page, that means
 * we intend to be scrolled down to a particular element.
 * In order to make the user see that they are being scrolled down
 * we wait for this amount of timeout before scrolling. If we do not
 * do this, then the scroll happens in a flash (without the user being
 * able to see where the scrolling started from)
 */
export const onLoadScrollToElementTimeout = 750;

export const scrollToEl = (idOfElToScrollTo: string, options?: Partial<SmoothBehaviorOptions>) => {
  const elToScrollTo = document && document.querySelector(idOfElToScrollTo);
  if (!elToScrollTo) {
    return;
  }

  scrollIntoView(elToScrollTo, options);
};

export const navigationElementId = 'details-navigation';
